"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4449],{

/***/ 26772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RY": function() { return /* reexport */ ClientContext; },
  "de": function() { return /* reexport */ ClientProvider; },
  "zt": function() { return /* reexport */ Provider; },
  "TN": function() { return /* reexport */ WishlistProvider; },
  "m8": function() { return /* reexport */ context_useClient; },
  "KZ": function() { return /* reexport */ useWishlistProvider; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../graphql/build/esm/client/index.js + 12 modules
var client = __webpack_require__(46371);
;// CONCATENATED MODULE: ../graphql/build/esm/context/Context.js


var ClientContext = (0,react.createContext)();
var Provider = ClientContext.Provider;

var ClientProvider = function ClientProvider(_ref) {
  var children = _ref.children,
    config = _ref.config,
    cookies = _ref.cookies,
    token = _ref.token;
  var memoizedClient = react.useMemo(function () {
    return (0,client/* client */.L)({
      config: config,
      cookies: cookies,
      token: token
    });
  }, [JSON.stringify(config), token]);
  return react.createElement(Provider, {
    value: memoizedClient
  }, children);
};
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../graphql/build/esm/hooks/index.js + 16 modules
var hooks = __webpack_require__(33267);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
;// CONCATENATED MODULE: ../graphql/build/esm/context/WishlistProvider.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }



var EMPTY_ID_ERROR_MSG = 'Empty userId';
var Context = (0,react.createContext)({});
var WishlistProvider = function WishlistProvider(_ref) {
  var children = _ref.children,
    values = _ref.values;
  var userId = values.userId;
  var hashId = userId == null ? void 0 : userId.slice(-4);
  var storage = (0,esm/* useStorage */.y$)('wishlist', hashId);
  var _useWishlist = (0,hooks/* useWishlist */.Ei)(),
    getWishlist = _useWishlist.getWishlist,
    useAddToWishlist = _useWishlist.addToWishlist,
    useRemoveFromWishlist = _useWishlist.removeFromWishlist;
  var checkUserId = function checkUserId() {
    var _storage$get;
    var storedId = (_storage$get = storage.get()) == null ? void 0 : _storage$get.id;
    return storage.exists() && storedId && hashId && storedId === hashId;
  };
  var updateWishlist = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      var _yield$getWishlist, data, error, _data$wishlist, remoteWishlist;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (userId) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", {
              error: EMPTY_ID_ERROR_MSG
            });
          case 2:
            if (!(!checkUserId() || (0,esm/* checkExpireIn */.k$)(storage.get()))) {
              _context.next = 13;
              break;
            }
            _context.next = 5;
            return getWishlist(userId);
          case 5:
            _yield$getWishlist = _context.sent;
            data = _yield$getWishlist.data;
            error = _yield$getWishlist.error;
            if (!(!error && data)) {
              _context.next = 12;
              break;
            }
            remoteWishlist = data == null ? void 0 : (_data$wishlist = data.wishlist) == null ? void 0 : _data$wishlist.items;
            storage.set(remoteWishlist);
            return _context.abrupt("return", {
              items: remoteWishlist
            });
          case 12:
            return _context.abrupt("return", {
              error: error
            });
          case 13:
            return _context.abrupt("return", {
              items: storage.get().items
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function updateWishlist() {
      return _ref2.apply(this, arguments);
    };
  }();
  var addToWishlist = function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2(args) {
      var _yield$useAddToWishli, data, error;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (userId) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", {
              error: EMPTY_ID_ERROR_MSG
            });
          case 2:
            if (!checkUserId()) {
              updateWishlist();
            }
            _context2.next = 5;
            return useAddToWishlist((0,esm_extends/* default */.Z)({}, args, {
              userId: userId
            }));
          case 5:
            _yield$useAddToWishli = _context2.sent;
            data = _yield$useAddToWishli.data;
            error = _yield$useAddToWishli.error;
            if (error) {
              _context2.next = 11;
              break;
            }
            storage.append({
              id: args.variationId,
              name: args.name,
              price: args.price
            });
            return _context2.abrupt("return", {
              data: data
            });
          case 11:
            return _context2.abrupt("return", (0,esm_extends/* default */.Z)({}, args, {
              error: error
            }));
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function addToWishlist(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var removeFromWishlist = function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee3(args) {
      var _yield$useRemoveFromW, data, error;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (userId) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return", {
              error: EMPTY_ID_ERROR_MSG
            });
          case 2:
            if (!checkUserId()) {
              updateWishlist();
            }
            _context3.next = 5;
            return useRemoveFromWishlist((0,esm_extends/* default */.Z)({}, args, {
              userId: userId
            }));
          case 5:
            _yield$useRemoveFromW = _context3.sent;
            data = _yield$useRemoveFromW.data;
            error = _yield$useRemoveFromW.error;
            if (error) {
              _context3.next = 11;
              break;
            }
            storage.remove(args.variationId);
            return _context3.abrupt("return", {
              data: data
            });
          case 11:
            return _context3.abrupt("return", (0,esm_extends/* default */.Z)({}, args, {
              error: error
            }));
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function removeFromWishlist(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var isOnWishlist = function isOnWishlist(variationId) {
    var _storage$get2, _storage$get2$items;
    return Boolean((_storage$get2 = storage.get()) == null ? void 0 : (_storage$get2$items = _storage$get2.items) == null ? void 0 : _storage$get2$items.find(function (item) {
      return item.id === variationId;
    }));
  };
  return react.createElement(Context.Provider, {
    value: {
      addToWishlist: addToWishlist,
      checkUserId: checkUserId,
      isOnWishlist: isOnWishlist,
      removeFromWishlist: removeFromWishlist,
      updateWishlist: updateWishlist
    }
  }, children);
};
var useWishlistProvider = function useWishlistProvider() {
  return (0,react.useContext)(Context);
};
;// CONCATENATED MODULE: ../graphql/build/esm/context/useClient.js


var useClient = function useClient() {
  return (0,react.useContext)(ClientContext);
};
/* harmony default export */ var context_useClient = (useClient);
;// CONCATENATED MODULE: ../graphql/build/esm/context/index.js




/***/ }),

/***/ 59271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ge": function() { return /* reexport */ bloglinkList_BlogLinkList; },
  "wc": function() { return /* reexport */ blogPost_BlogPost; },
  "Cn": function() { return /* reexport */ blogRecommendation_BlogRecommendations; },
  "QM": function() { return /* reexport */ blogSeo_BlogSeo; },
  "$v": function() { return /* reexport */ blogTag_BlogTag; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/src/index.js
var src = __webpack_require__(30382);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogPost/BlogPost.js

var _templateObject;

var BlogPost = src_default()(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment posts on PostItem {\n    id\n    title\n    subtitle\n    slug\n    publishedAt\n    updatedAt\n    categoryId\n    categorySlug\n    categoryTitle\n    category {\n      id\n      title\n      categoryId\n    }\n    subcategory {\n      id\n      title\n      categoryId\n      slug\n    }\n    image {\n      alt\n      urls {\n        default\n        thumbnail\n        small\n        medium\n        large\n      }\n    }\n  }\n"])));
/* harmony default export */ var blogPost_BlogPost = (BlogPost);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogPost/index.js

;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogRecommendation/BlogRecommendations.js

var BlogRecommendations_templateObject;


var BlogRecommendations = src_default()(BlogRecommendations_templateObject || (BlogRecommendations_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment recommendations on BlogRecommendation {\n    id\n    title\n    variation\n    categoryId\n    postIds\n    link\n    quantity\n    blogCategoryId\n    parentCategoryId\n    theme {\n      background\n      card\n    }\n    posts {\n      ...posts\n    }\n  }\n  ", "\n"])), blogPost_BlogPost);
/* harmony default export */ var blogRecommendation_BlogRecommendations = (BlogRecommendations);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogRecommendation/index.js

;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogSeo/BlogSeo.js

var BlogSeo_templateObject;

var BlogSeo = src_default()(BlogSeo_templateObject || (BlogSeo_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment seo on ComponentBlogSeo {\n    title\n    description\n  }\n"])));
/* harmony default export */ var blogSeo_BlogSeo = (BlogSeo);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogSeo/index.js

;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogTag/BlogTag.js

var BlogTag_templateObject;

var BlogTag = src_default()(BlogTag_templateObject || (BlogTag_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment tags on PostTag {\n    id\n    title\n    slug\n  }\n"])));
/* harmony default export */ var blogTag_BlogTag = (BlogTag);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/blogTag/index.js

;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/bloglinkList/BlogLinkList.js

var BlogLinkList_templateObject;

var BlogLinkList = src_default()(BlogLinkList_templateObject || (BlogLinkList_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment linkList on ComponentPresentationLinkList {\n    href\n    value\n    alt\n  }\n"])));
/* harmony default export */ var bloglinkList_BlogLinkList = (BlogLinkList);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/bloglinkList/index.js

;// CONCATENATED MODULE: ../graphql/build/esm/fragments/blogFragments/index.js






/***/ }),

/***/ 48248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_Z": function() { return /* reexport */ ChatMessageError; },
  "Hc": function() { return /* reexport */ chatFragments_ChatMessage; }
});

// UNUSED EXPORTS: LinkListFragment, PostFragment, RecommendationsFragment, SeoFragment, TagFragment

// EXTERNAL MODULE: ../graphql/build/esm/fragments/blogFragments/index.js + 10 modules
var blogFragments = __webpack_require__(59271);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/src/index.js
var src = __webpack_require__(30382);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/chatFragments/ChatMessage.js

var _templateObject, _templateObject2;

var ChatMessage = src_default()(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment chatMessage on ChatMessage {\n    id\n    fromUser {\n      id\n      fullName\n      refKey\n      type\n    }\n    toUser {\n      id\n      fullName\n      refKey\n      type\n    }\n    content\n    readBy\n    moderation {\n      status\n      whenAt\n    }\n    customFields {\n      name\n      value\n    }\n    whenAt\n  }\n"])));
var ChatMessageError = src_default()(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fragment chatMessageError on ChatErrorResponse {\n    message\n    slug\n    stack\n    detail {\n      loc\n      msg\n    }\n  }\n"])));
/* harmony default export */ var chatFragments_ChatMessage = (ChatMessage);
;// CONCATENATED MODULE: ../graphql/build/esm/fragments/chatFragments/index.js


;// CONCATENATED MODULE: ../graphql/build/esm/fragments/index.js



/***/ })

}]);